import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataViewer } from '../../../abstract/DataViewer';
import { TabType } from '../../../enums/TabType';
import { MainComponent } from '../../../pages/main/main.component';

@Component({
  selector: 'data-view-actions',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './data-view-actions.component.html',
  styleUrl: './data-view-actions.component.scss'
})
export class DataViewActionsComponent {
  @Input({ required: true }) mainComponent!: MainComponent;
  @Input({ required: true }) dataViewer!: DataViewer;
  @Input({ required: true }) currentTabType!: TabType;

  protected readonly TabType = TabType;

  changeTabType(tabType: TabType) {
    const targetTabType = this.currentTabType === tabType ? TabType.VIEW : tabType;
    this.mainComponent.changeTabType(targetTabType);
  }
}
